import { Link } from "react-router-dom";

export function Cta() {
  return (
    <section className="t-cta" data-section="cta">
      <div className="t-cta-inner">
        <p className="t-kicker">Next step</p>
        <h2 className="t-cta-title">Tell us about your product</h2>
        <p className="t-cta-sub">
          Share the category and your budget. We reply with a fixed quote and, for qualifying
          sellers, a free sample.
        </p>
        <Link to="/quote" className="t-btn t-btn-primary">
          Request a quote
        </Link>
      </div>
    </section>
  );
}
